import { createI18n } from 'vue-i18n';
import { en } from './locales/en.ts';
import { ru } from './locales/ru.ts';

export const LOCALES = ['en', 'ru'] as const;
export type LocaleCode = (typeof LOCALES)[number];

const STORAGE_KEY = 'formplat.locale';

function initialLocale(): LocaleCode {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'en' || stored === 'ru') return stored;
  return navigator.language.toLowerCase().startsWith('ru') ? 'ru' : 'en';
}

export const i18n = createI18n({ legacy: false, locale: initialLocale(), fallbackLocale: 'en', messages: { en, ru } });

export function setLocale(locale: LocaleCode): void {
  i18n.global.locale.value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}

document.documentElement.lang = i18n.global.locale.value;
